import ApiService, { ApiArguments } from '@/api/api_service';
import { PromptJsonKeyApi } from '@/api/openapi';

export class PromptJsonKeyService extends ApiService {
  api = new PromptJsonKeyApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTimelinePromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getTimelinePromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getDealAcquiredJudgmentPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getDealAcquiredJudgmentPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getHearingItemExtractionPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getHearingItemExtractionPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getFollowUpNecessityJudgmentPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getFollowUpNecessityJudgmentPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getSpeakerIdentificationPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getSpeakerIdentificationPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getQualitativeFeedbackPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getQualitativeFeedbackPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getVoicemailJudgmentPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getVoicemailJudgmentPromptJsonKeys(options),
      errorHandlers,
    );
  }

  async getAiFeedbackPromptJsonKeys({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getAiFeedbackPromptJsonKeys(options),
      errorHandlers,
    );
  }
}
